import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";

const REASONS = ["Not available at this time", "Too far from my location", "Don't have the right tools", "Emergency / personal reason"];

// A Pro can hand the job back only before marking On The Way; it is re-dispatched to other nearby pros.
export function ProReleaseJob({ b }) {
    const nav = useNavigate();
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [busy, setBusy] = useState(false);
    if (!["PROFESSIONAL ASSIGNED", "CONFIRMED"].includes(b.status)) return null;
    const release = async () => {
        setBusy(true);
        try { await api.post(`/bookings/${b.id}/cancel`, { reason }); toast.success("Job released — it will be offered to other pros"); nav("/pro"); }
        catch (err) { toast.error(apiError(err.response?.data?.detail)); }
        finally { setBusy(false); }
    };
    if (!open) return <button data-testid="pro-release-job-btn" onClick={() => setOpen(true)} className="mx-auto flex items-center gap-1.5 text-xs font-semibold text-red-500"><Undo2 size={14} /> Can't do this job? Release it (only before On The Way)</button>;
    return (
        <div data-testid="pro-release-form" className="space-y-2 rounded-2xl border border-red-200 bg-red-50 p-3">
            <select data-testid="pro-release-reason" value={reason} onChange={(e) => setReason(e.target.value)} className="w-full rounded-xl border border-navy/15 bg-white px-3 py-2 text-sm outline-none">
                <option value="">Select reason…</option>
                {REASONS.map((r) => <option key={r}>{r}</option>)}
            </select>
            <div className="flex gap-2">
                <button data-testid="pro-release-confirm" disabled={busy || !reason} onClick={release} className="flex-1 rounded-full bg-red-500 py-2 text-sm font-bold text-white disabled:opacity-50">Release job</button>
                <button onClick={() => setOpen(false)} className="rounded-full border border-navy/15 px-4 text-sm font-bold text-navy/60">Keep</button>
            </div>
        </div>
    );
}
